import { render, staticRenderFns } from "./ModalDmm.vue?vue&type=template&id=28a7cbbe&"
import script from "./ModalDmm.vue?vue&type=script&lang=js&"
export * from "./ModalDmm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports